import { makeStyles } from '@material-ui/core/styles';

import wavesImg from 'assets/images/waves.png';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#fdfdfd',
    backgroundPositionY: 'bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${wavesImg})`,
  },
  container: {
    width: '100%',
    maxWidth: 420,
    padding: `${theme.spacing(6)}px ${theme.spacing(5)}px`,
    backgroundColor: '#fff',

    display: 'flex',
    flexDirection: 'column',
  },
  goBack: {
    fontSize: 16,
    textDecoration: 'none',
    color: theme.palette.text.primary,

    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',

    '&:hover': {
      '& > svg': {
        transform: 'translateX(-5px)',
      },
    },
  },
  title: {
    fontSize: 32,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  subtitle: {
    color: theme.palette.text.primary,
  },
  backIcon: {
    fontSize: 24,
    transition: 'transform .4s',
    marginRight: 4,
  },
}));
